import styled from '@emotion/styled';

import { blockingColors, blockingMetrics, blockingTypography } from '../tokens';

const { mobileBreakpoint } = blockingMetrics;

export const CardRoot = styled('section')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  background: ${blockingColors.surface};
  border-radius: ${blockingMetrics.radius};
`;

export const MainRow = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${blockingMetrics.cardGap};
  width: 100%;

  @media (max-width: ${mobileBreakpoint}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${blockingMetrics.cardGapMobile};
  }
`;

export const Content = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${blockingMetrics.cardGap};
  min-width: 0;

  @media (max-width: ${mobileBreakpoint}) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
`;

export const IconCircle = styled('span')`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${blockingMetrics.iconSize};
  height: ${blockingMetrics.iconSize};
  padding: 12px;
  box-sizing: border-box;
  background: ${blockingColors.iconCircle};
  border-radius: ${blockingMetrics.radiusPill};
  color: ${blockingColors.iconGlyph};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const TextBlock = styled('div')`
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: ${blockingMetrics.cardTextWidth};

  @media (max-width: ${mobileBreakpoint}) {
    width: 100%;
  }
`;

export const CardTitle = styled('h2')`
  margin: 0;
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.cardTitle.size};
  font-weight: ${blockingTypography.cardTitle.weight};
  line-height: ${blockingTypography.cardTitle.lineHeight};
  color: ${blockingColors.text};
`;

export const CardDescription = styled('p')`
  margin: 0;
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.cardBody.size};
  font-weight: ${blockingTypography.cardBody.weight};
  line-height: ${blockingTypography.cardBody.lineHeight};
  color: ${blockingColors.text};

  strong {
    font-weight: 700;
  }
`;

export const InlineLink = styled('button')`
  display: inline;
  padding: 0;
  border: none;
  background: none;
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.cardBody.size};
  font-weight: 700;
  line-height: ${blockingTypography.cardBody.lineHeight};
  color: ${blockingColors.actionBlue};
  cursor: pointer;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`;

export const Actions = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${blockingMetrics.cardGap};
  flex-shrink: 0;

  @media (max-width: ${mobileBreakpoint}) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    width: 100%;
  }
`;

export const ActionButton = styled('button', {
  shouldForwardProp: (prop) => prop !== '$variant',
})<{ $variant: 'primary' | 'secondary' }>`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: ${blockingMetrics.actionWidth};
  min-width: 98px;
  max-width: ${blockingMetrics.actionMaxWidth};
  height: ${blockingMetrics.actionHeight};
  padding: 12px 16px;
  border-radius: ${blockingMetrics.radiusPill};
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.actionLabel.size};
  font-weight: ${blockingTypography.actionLabel.weight};
  line-height: ${blockingTypography.actionLabel.lineHeight};
  text-align: center;
  cursor: pointer;

  border: 1px solid ${blockingColors.actionBlue};
  background: ${({ $variant }) =>
    $variant === 'primary' ? blockingColors.actionBlue : 'transparent'};
  color: ${({ $variant }) =>
    $variant === 'primary' ? blockingColors.white : blockingColors.actionBlue};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  @media (max-width: ${mobileBreakpoint}) {
    width: 100%;
    max-width: none;
  }
`;

export const Extra = styled('div')`
  width: 100%;
  margin-top: 16px;
`;
